import React, { Component } from 'react';
import Slider from 'react-slick';
import Intro from '../global/IntroWithWatermark';
import ArrowButton from '../ui/ArrowButton';
import PinSvg from './assets/onboarding/PinSvg';
import SwipeSvg from './assets/onboarding/SwipeSvg';
import style from './onboarding.module.scss';

const OnboardingIntro = () => (
  <Intro
    watermark={`LES`}
    label={`Henry Street Settlement`}
    title={`<strong>Walking Tour</strong>`}
  />
);

const Slide1 = () => (
  <div>
    <p className={style.text}>
      Explore the neighborhood the
      <strong> Henry Street Settlement </strong>
      calls home.
    </p>
  </div>
);

const Slide2 = () => (
  <div>
    <p className={style.text}>
      <span className={style.pinIcon}>
        <PinSvg />
      </span>
      <strong>Tap the pins</strong> to explore different locations
    </p>
  </div>
);

const Slide3 = () => (
  <div>
    <p className={style.text}>
      <span className={style.swipeIcon}>
        <SwipeSvg />
      </span>
      <strong>swipe up</strong> to uncover more information
    </p>
  </div>
);

class Onboarding extends Component {
  slickOptions = {
    dots: true,
    infinite: false,
    draggable: true,
    speed: 500,
    // cssEase: 'cubic-bezier(.9, 0, .3, 1)',
    nextArrow: <ArrowButton direction={'right'} />,
    prevArrow: <ArrowButton direction={'left'} />,
  };

  ExploreButton = (
    <button
      className={style.button}
      onClick={this.props.handleEnterFromOnboarding}
    >
      Enter
    </button>
  );

  componentDidMount() {
    this.forceUpdate();
  }
  render() {
    const slides = [<OnboardingIntro />, <Slide1 />, <Slide2 />, <Slide3 />];
    if (typeof window !== 'undefined' && this.props.isMobileDevice === true) {
      return (
        <div className={`${style.wrapper} ${style[this.props.status]}`}>
          <Slider
            className={`onboarding-slick ${style.slickWrap}`}
            {...this.slickOptions}
          >
            {slides.map((slide, index) => (
              <div key={`${index}-onboarding-slide`}>
                {slide}
                {index === slides.length - 1 ? this.ExploreButton : null}
              </div>
            ))}
          </Slider>
        </div>
      );
    } else {
      return (
        <div
          key={'onboarding'}
          className={`${style.wrapper} ${style[this.props.status]}`}
        >
          <div className={style.verticalCenter}>
            <OnboardingIntro />
            <Slide1 />
            <Slide2 />
            <button
              className={style.button}
              onClick={this.props.handleEnterFromOnboarding}
            >
              Enter
            </button>
          </div>
        </div>
      );
    }
  }
}

export default Onboarding;



// WEBPACK FOOTER //
// ./src/components/tour/Onboarding.js